export default "__VITE_ASSET__VbAeANkW__"